import Vue from 'vue';
import searchableProducts from '../components/searchableProducts/index';

import pl from 'vee-validate/dist/locale/pl';
import en from 'vee-validate/dist/locale/en';

import VueI18n from 'vue-i18n';
import VeeValidate, { Validator } from 'vee-validate';

import vuetify from '../plugins/vuetify';
import { locale } from '../plugins/locale-switcher';

import messages from '../locales/index';
import isUnique from '../validators/isUnique';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: locale,
  messages,
});

Vue.use(VeeValidate, {
  i18n,
  locale: locale,
  dictionary: { locale },
});

Validator.extend('unique', isUnique);

new Vue({
  i18n,
  vuetify,
  render: h => h(searchableProducts),
}).$mount('#searchable-products');
